
const url = '/stats';

const unit = () => ({ method: 'get', url: `${url}/unit` });



export default {
  unit,
};